module.exports = __webpack_public_path__ + "static/media/HT-Series.105fe2e2.png";